/** Export Audio (owner session cookie): one song → full mix + stems, 24-bit 48 kHz WAV + MP3, in a Studio One-ready zip. */
import axios from "axios";
import { API } from "@/lib/creatorApi";

const http = axios.create({ baseURL: `${API}/export-audio`, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const EXPORT_ACTIVE = ["queued", "running"];
export const STEM_CHOICES = [["groups", "Grouped"], ["all", "Every part"], ["both", "Both"], ["none", "None"]];
export const GROUP_COLORS = { lead: "#f8fafc", bgv: "#c4b5fd", instrumental: "#fcd34d" };

export const listExportSongs = (q) => data(http.get("/songs", { params: q ? { q } : {} }));
export const getExportSong = (id) => data(http.get(`/songs/${id}`));
export const createExport = (body) => data(http.post("", body));
export const listExports = (songId) => data(http.get("", { params: songId ? { song_id: songId } : {} }));
export const getExport = (id) => data(http.get(`/${id}`));
export const deleteExport = (id) => data(http.delete(`/${id}`));
export const splitSong = (id) => axios.post(`${API}/studio/songs/${id}/stems`, { parts: 6 }, { withCredentials: true }).then((r) => r.data);
export const fileUrl = (u) => `${process.env.REACT_APP_BACKEND_URL}${u}`;

export const mb = (bytes) => (bytes >= 1e9 ? `${(bytes / 1e9).toFixed(2)} GB` : `${(bytes / 1e6).toFixed(1)} MB`);
export const phaseText = (doc) => {
  const m = /^files:(\d+)\/(\d+)$/.exec(doc.phase || "");
  if (m) return `Making the files (${m[1]} of ${m[2]} done)`;
  return { queued: "Getting ready", loading: "Gathering the song and its parts", zipping: "Packing the zip" }[doc.phase] || "Working";
};
